// C1-INT - Ünite 2: Havayolu Spesifik Sorular
// Şirkete özel mülakat hazırlığı ve gerçekçi senaryolar

export const C1INT_UNIT_2 = {
  'C1INT-U2-L1': {
    id: 'C1INT-U2-L1',
    title: 'Turkish Airlines Hakkında',
    type: 'theory',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🇹🇷 Turkish Airlines Mülakat Hazırlığı',
          content: 'THY mülakatına girmeden önce şirketi tanımanız kritik. "Why Turkish Airlines?" sorusu %100 sorulacak.'
        },
        {
          type: 'info',
          title: '📊 THY Temel Bilgiler (2024)',
          content: '• **Kuruluş:** 1933 (90+ yıl tarih)\n• **Hub:** İstanbul Havalimanı (IST)\n• **Filo:** 400+ uçak\n• **Destinasyon:** 340+ şehir, 129 ülke (dünyada en fazla ülkeye uçan)\n• **Slogan:** "Widen Your World"\n• **Yıldız İttifakı:** Star Alliance üyesi\n• **Ödüller:** Skytrax "Best Airline in Europe" (birçok kez)\n• **Özellik:** Turkish Hospitality - Türk misafirperverliği'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: Why Turkish Airlines?',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'So, why do you want to work for Turkish Airlines specifically?',
              translation: 'Peki, özellikle neden Türk Hava Yolları\'nda çalışmak istiyorsunuz?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'Turkish Airlines represents something unique in aviation—the perfect blend of modern excellence and genuine warmth. You fly to more countries than any other airline, which means incredible diversity in both passengers and experiences.',
              translation: 'Türk Hava Yolları havacılıkta benzersiz bir şeyi temsil ediyor—modern mükemmellik ve gerçek sıcaklığın mükemmel karışımı. Diğer tüm havayollarından daha fazla ülkeye uçuyorsunuz, bu da hem yolcularda hem deneyimlerde inanılmaz çeşitlilik demek.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'But what really draws me is the concept of Turkish hospitality. I\'ve read about how THY crew members are trained to treat passengers like guests in their own home. That philosophy aligns perfectly with my own service values—I believe in genuine care, not just polite scripts.',
              translation: 'Ama beni gerçekten çeken şey Türk misafirperverliği kavramı. THY ekip üyelerinin yolculara kendi evlerindeki misafirler gibi davranmak üzere eğitildiğini okudum. Bu felsefe kendi hizmet değerlerimle mükemmel örtüşüyor—sadece kibar senaryolara değil, gerçek ilgiye inanıyorum.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'What do you know about our recent developments?',
              translation: 'Son gelişmelerimiz hakkında ne biliyorsunuz?'
            },
            {
              speaker: 'Aday',
              text: 'I know Istanbul Airport has become a major global hub, and THY has been expanding its fleet significantly. I also read about your sustainability initiatives and the new business class products. The investment in passenger experience shows this isn\'t just about growth—it\'s about quality growth.',
              translation: 'İstanbul Havalimanı\'nın büyük bir küresel hub haline geldiğini ve THY\'nin filosunu önemli ölçüde genişlettiğini biliyorum. Sürdürülebilirlik girişimlerinizi ve yeni business class ürünlerini de okudum. Yolcu deneyimine yapılan yatırım bunun sadece büyümeyle ilgili olmadığını gösteriyor—kaliteli büyümeyle ilgili.'
            }
          ]
        },
        {
          type: 'warning',
          title: '❌ Kaçınılması Gereken Cevaplar',
          content: '• "Çünkü ev yakın / Türkiye\'de çalışmak istiyorum"\n• "Maaşlar iyi diye duydum"\n• "Başka yere başvurdum olmadı"\n• "Uniform güzel" (gerçekten sorulur!)\n• Şirket hakkında hiçbir şey bilmemek'
        },
        {
          type: 'tip',
          content: '💡 **Araştırma Kontrol Listesi:**\n✓ THY resmi web sitesi\n✓ Son haberler (Google News)\n✓ Skytrax değerlendirmeleri\n✓ LinkedIn - THY çalışan yorumları\n✓ YouTube - THY tanıtım videoları'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'THY\'nin en önemli farkı:',
          options: [
            'En ucuz biletler',
            'En fazla ülkeye uçan havayolu + Türk misafirperverliği',
            'En eski havayolu',
            'Sadece Türkiye\'de uçması'
          ],
          correctIndex: 1,
          explanation: 'THY 129 ülkeye uçarak dünyada en fazla ülkeye uçan havayoludur. Türk misafirperverliği ana marka değeridir.'
        }
      ]
    }
  },

  'C1INT-U2-L2': {
    id: 'C1INT-U2-L2',
    title: 'Emirates/Etihad/Qatar Hakkında',
    type: 'theory',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🌟 Gulf Carriers - Körfez Havayolları',
          content: 'Emirates, Etihad ve Qatar Airways dünyanın en prestijli havayolları arasında. Mülakatlarında mükemmellik aranır.'
        },
        {
          type: 'info',
          title: '✈️ Emirates (Dubai)',
          content: '• **Hub:** Dubai (DXB)\n• **Slogan:** "Fly Better"\n• **Özellik:** A380 filosu, lüks hizmet\n• **Filo:** 260+ uçak\n• **Kültür:** Çok uluslu, 140+ milletten çalışan\n• **Ünlü:** First class shower spa, onboard lounge\n• **Mülakat:** Dubai\'de assessment day, çok aşamalı'
        },
        {
          type: 'info',
          title: '✈️ Qatar Airways (Doha)',
          content: '• **Hub:** Hamad International Airport (DOH)\n• **Slogan:** "Going Places Together"\n• **Özellik:** Skytrax "World\'s Best Airline" (birçok kez)\n• **Filo:** 230+ uçak\n• **Kültür:** Premium hizmet, detaycı\n• **Ünlü:** Qsuite business class\n• **Mülakat:** Open day formatı yaygın'
        },
        {
          type: 'info',
          title: '✈️ Etihad Airways (Abu Dhabi)',
          content: '• **Hub:** Abu Dhabi (AUH)\n• **Slogan:** "Choose Well"\n• **Özellik:** "Boutique" yaklaşım, daha küçük ama premium\n• **Filo:** 100+ uçak\n• **Kültür:** Lüks, detay odaklı\n• **Ünlü:** The Residence (uçan daire)\n• **Mülakat:** Daha kişisel, derinlemesine'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: Why Emirates?',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Why do you want to join Emirates?',
              translation: 'Neden Emirates\'e katılmak istiyorsunuz?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'Emirates represents the pinnacle of aviation luxury and service excellence. Your commitment to innovation—from the A380 experience to the latest IFE systems—shows a company that never settles for "good enough."',
              translation: 'Emirates havacılık lüksü ve hizmet mükemmelliğinin zirvesini temsil ediyor. A380 deneyiminden en son IFE sistemlerine kadar yeniliğe olan bağlılığınız, "yeterince iyi" ile asla yetinmeyen bir şirketi gösteriyor.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I\'m also drawn to the multicultural environment. Working with colleagues from 140 nationalities would help me grow both personally and professionally. Dubai as a hub means connecting the world—literally being at the crossroads of East and West.',
              translation: 'Ayrıca çok kültürlü ortam beni çekiyor. 140 milletten meslektaşlarla çalışmak hem kişisel hem profesyonel olarak büyümeme yardımcı olur. Hub olarak Dubai dünyayı birleştirmek demek—tam anlamıyla Doğu ve Batı\'nın kavşağında olmak.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'Are you willing to relocate to Dubai?',
              translation: 'Dubai\'ye taşınmaya istekli misiniz?'
            },
            {
              speaker: 'Aday',
              text: 'Absolutely. Living in Dubai is actually part of the appeal for me. I\'ve researched the lifestyle, the multicultural community, and the opportunities the city offers. I\'m ready for this adventure.',
              translation: 'Kesinlikle. Dubai\'de yaşamak aslında benim için çekiciliğin bir parçası. Yaşam tarzını, çok kültürlü topluluğu ve şehrin sunduğu fırsatları araştırdım. Bu maceraya hazırım.'
            }
          ]
        },
        {
          type: 'tip',
          content: '💡 **Körfez Havayolları Ortak Soruları:**\n• Are you willing to relocate? (Her zaman "Yes" + heyecan göster)\n• How do you feel about sharing accommodation? (Olumlu, deneyim olarak sun)\n• Can you work on religious holidays? (Evet, profesyonellik)\n• How would your family feel? (Destekliyorlar, karar benim)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Körfez havayolları mülakatında "Are you willing to relocate?" sorusuna:',
          options: [
            '"Düşünmem lazım"',
            '"Maaş iyi olursa evet"',
            '"Kesinlikle, bu benim için heyecan verici bir fırsat"',
            '"Ailem izin verirse"'
          ],
          correctIndex: 2,
          explanation: 'Tereddüt göstermek = Red. Heyecan ve hazırlık göstermelisiniz.'
        }
      ]
    }
  },

  'C1INT-U2-L3': {
    id: 'C1INT-U2-L3',
    title: 'European Airlines (Lufthansa, BA, AF)',
    type: 'theory',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🇪🇺 Avrupa Havayolları',
          content: 'Avrupa havayolları farklı kültürler ve beklentiler sunar. Her birinin kendine özgü değerleri var.'
        },
        {
          type: 'info',
          title: '✈️ Lufthansa (Almanya)',
          content: '• **Hub:** Frankfurt (FRA), Münih (MUC)\n• **Slogan:** "Say yes to the world"\n• **Kültür:** Alman dakikliği, verimlilik, güvenilirlik\n• **Özellik:** Teknik mükemmellik, güvenlik odaklı\n• **Değerler:** Punctuality, precision, professionalism\n• **Mülakat:** Yapılandırılmış, teknik sorular olabilir'
        },
        {
          type: 'info',
          title: '✈️ British Airways (İngiltere)',
          content: '• **Hub:** London Heathrow (LHR)\n• **Slogan:** "To Fly. To Serve."\n• **Kültür:** Britanya nezaketi, understatement\n• **Özellik:** Premium hizmet, tarih ve gelenek\n• **Değerler:** Courtesy, composure, quality\n• **Mülakat:** Behavioral ağırlıklı, senaryolar'
        },
        {
          type: 'info',
          title: '✈️ Air France (Fransa)',
          content: '• **Hub:** Paris Charles de Gaulle (CDG)\n• **Slogan:** "France is in the air"\n• **Kültür:** Fransız zarafeti, gastronomi odaklı\n• **Özellik:** Şıklık, French touch\n• **Değerler:** Elegance, savoir-faire, cuisine\n• **Mülakat:** Stil ve prezentasyon önemli'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: Why British Airways?',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'What attracts you to British Airways?',
              translation: 'British Airways\'de sizi ne çekiyor?'
            },
            {
              speaker: 'Aday',
              text: 'British Airways has a heritage that few airlines can match—over a century of aviation history. But what truly attracts me is how you balance tradition with innovation. The "To Fly. To Serve." motto isn\'t just words—it\'s evident in how BA crew members carry themselves with quiet professionalism.',
              translation: 'British Airways\'in çok az havayolunun eşleşebileceği bir mirası var—bir asrı aşkın havacılık tarihi. Ama beni gerçekten çeken şey geleneği yenilikle nasıl dengelediğiniz. "To Fly. To Serve." sloganı sadece kelime değil—BA ekip üyelerinin sessiz profesyonellikle kendilerini nasıl taşıdıklarında belli.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I also appreciate the British approach to service—warm but not overbearing, helpful without being intrusive. That resonates with my own philosophy of anticipating needs rather than asking constant questions.',
              translation: 'Ayrıca hizmete British yaklaşımını takdir ediyorum—sıcak ama baskıcı değil, yardımsever ama müdahaleci değil. Bu, sürekli soru sormak yerine ihtiyaçları önceden tahmin etme felsefemle örtüşüyor.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'How would you handle a passenger who is being rude?',
              translation: 'Kaba davranan bir yolcuyu nasıl yönetirsiniz?'
            },
            {
              speaker: 'Aday',
              text: 'I\'d maintain composure—that\'s essential. I\'d listen without being defensive, acknowledge their frustration, and focus on finding a solution. Often rudeness comes from feeling unheard. If I can make them feel understood, the situation usually de-escalates. And if it doesn\'t, I\'d know when to involve a senior crew member.',
              translation: 'Soğukkanlılığımı korurdum—bu temel. Savunmacı olmadan dinler, hayal kırıklıklarını kabul eder ve çözüm bulmaya odaklanırdım. Genellikle kabalık duyulmama hissinden gelir. Onları anlaşılmış hissettirirsem, durum genellikle sakinleşir. Ve olmazsa, ne zaman kıdemli bir ekip üyesini dahil edeceğimi bilirdim.'
            }
          ]
        },
        {
          type: 'tip',
          content: '💡 **Avrupa vs Körfez Farkları:**\n\n**Körfez:** Glamour, luxury, Dubai/Doha yaşamı, genç ve dinamik\n**Avrupa:** Work-life balance, eve yakın, kariyer uzunluğu, sendika hakları\n\nMülakatınızda bunları bildiğinizi gösterin—doğru motivasyonla geldiğinizi kanıtlar.'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'British Airways mülakatında vurgulanması gereken:',
          options: [
            'Lüks ve glamour beklentisi',
            'Sessiz profesyonellik, gelenek ve composure',
            'Yüksek maaş beklentisi',
            'Parti hayatı'
          ],
          correctIndex: 1,
          explanation: 'BA kültürü: Understatement, composure, quiet professionalism.'
        }
      ]
    }
  },

  'C1INT-U2-L4': {
    id: 'C1INT-U2-L4',
    title: 'What sets you apart from other candidates?',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Bu Soru Neden Kritik?',
          content: 'Havayolu mülakatları yüzlerce adayla yapılır. Bu soru, neden SİZİ seçmeleri gerektiğini anlatma şansınız.\n\n**Dikkat:** Kibirli olmadan kendini satmak zor bir denge. Anahtar: somut örnekler.'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: Unique Selling Point',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'We have hundreds of applicants. What makes you different from everyone else?',
              translation: 'Yüzlerce başvurumuz var. Sizi diğerlerinden farklı kılan ne?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'I believe it\'s my combination of hospitality experience and genuine curiosity about people. I\'ve worked in hotels for three years, but what sets me apart isn\'t just the experience—it\'s the approach.',
              translation: 'Bence bu, konaklama deneyimim ve insanlara karşı gerçek merakımın birleşimi. Üç yıl otellerde çalıştım, ama beni farklı kılan sadece deneyim değil—yaklaşımım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'For example, I taught myself basic phrases in five languages because I noticed how guests\' faces light up when you greet them in their language. It\'s a small thing, but it transforms a transaction into a connection.',
              translation: 'Örneğin, misafirlerin kendi dillerinde selamlandığında yüzlerinin nasıl aydınlandığını fark ettiğim için kendime beş dilde temel ifadeler öğrettim. Küçük bir şey, ama bir işlemi bağlantıya dönüştürüyor.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'That\'s interesting. Can you give me an example of when this made a difference?',
              translation: 'Bu ilginç. Bunun fark yarattığı bir örnek verebilir misiniz?'
            },
            {
              speaker: 'Aday',
              text: 'Of course. A Japanese family was checking in, clearly exhausted after a long flight. When I greeted them with "Irasshaimase" and offered green tea, the mother actually teared up. She later told me it was their first trip abroad and they had been nervous. That greeting made them feel safe.',
              translation: 'Tabii. Japon bir aile check-in yapıyordu, uzun bir uçuştan sonra açıkça yorgunlardı. "Irasshaimase" diye selamladığımda ve yeşil çay teklif ettiğimde, anne aslında gözleri yaşardı. Daha sonra bunun ilk yurt dışı seyahatleri olduğunu ve gergin olduklarını söyledi. O selamlama onları güvende hissettirdi.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I want to bring that same attention to cultural nuances to cabin crew work. Flying is vulnerable for many people, and small touches can make an enormous difference.',
              translation: 'Aynı kültürel nüanslara dikkat etmeyi kabin memurluğuna getirmek istiyorum. Uçmak birçok insan için savunmasız bir durum ve küçük dokunuşlar büyük fark yaratabilir.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Cevap Analizi',
          content: '✅ **Neden etkili:**\n• Somut beceri (5 dil temel ifadeler)\n• Motivasyon açıklaması (misafirlerin tepkisi)\n• Duygusal hikaye (Japon aile)\n• Havacılığa bağlantı (uçmak savunmasız, küçük dokunuşlar)\n• Kibir yok, hikaye var'
        },
        {
          type: 'scenario',
          title: '❌ Kaçınılması Gereken Cevaplar',
          dialogues: [
            {
              speaker: 'Kötü Cevap 1',
              text: 'I\'m very hardworking and I really want this job.',
              translation: 'Çok çalışkanım ve bu işi gerçekten istiyorum.'
            },
            {
              speaker: 'Kötü Cevap 2',
              text: 'I think I\'m better than most candidates because I have a degree in tourism.',
              translation: 'Turizm diplomam olduğu için çoğu adaydan daha iyi olduğumu düşünüyorum.'
            },
            {
              speaker: 'Kötü Cevap 3',
              text: 'I\'m tall, I have a good smile, and I look good in uniform.',
              translation: 'Uzunum, güzel gülümsemem var ve üniformada iyi görünüyorum.'
            }
          ]
        },
        {
          type: 'warning',
          title: '⚠️ Sorunlar',
          content: '**Cevap 1:** Herkes aynı şeyi söyler, farklılaştırmıyor\n**Cevap 2:** Kibirli, diploma tek başına yetmez\n**Cevap 3:** Yüzeysel, hizmet odaklı değil'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '"What sets you apart?" sorusunda EN ETKİLİ strateji:',
          options: [
            'Tüm başarılarınızı listelemek',
            'Somut bir hikaye + bunun havacılıkta nasıl fark yaratacağı',
            'Fiziksel özelliklerinizi vurgulamak',
            'Diğer adayları eleştirmek'
          ],
          correctIndex: 1,
          explanation: 'Hikayeler akılda kalır. Farkınızı somut örnekle gösterin ve havayoluna bağlayın.'
        }
      ]
    }
  },

  'C1INT-U2-L5': {
    id: 'C1INT-U2-L5',
    title: 'Pratik: Şirket Araştırma',
    type: 'practice',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🔍 Şirket Araştırma Rehberi',
          content: 'Her havayolu mülakatından önce yapmanız gereken araştırma kontrol listesi.'
        },
        {
          type: 'checklist',
          title: '✅ Araştırma Kontrol Listesi',
          content: '**Temel Bilgiler:**\n□ Hub havalimanı neresi?\n□ Kaç destinasyona uçuyor?\n□ Filo büyüklüğü ve uçak tipleri?\n□ Hangi ittifaka üye? (Star Alliance, Oneworld, SkyTeam)\n□ Slogan/motto nedir?\n\n**Son Gelişmeler (Google News):**\n□ Son 6 ayda önemli haberler?\n□ Yeni rotalar veya uçak siparişleri?\n□ Ödüller veya başarılar?\n□ Zorluklar veya değişiklikler?\n\n**Kültür ve Değerler:**\n□ Şirket misyonu ve vizyonu?\n□ Çalışan yorumları (Glassdoor, LinkedIn)?\n□ Müşteri yorumları (Skytrax)?\n□ Eğitim ve kariyer fırsatları?\n\n**Mülakat Spesifik:**\n□ Mülakat formatı ne? (Open day, assessment, video?)\n□ Dress code beklentisi?\n□ Kaç aşama var?\n□ Hangi şehirlerde mülakat?'
        },
        {
          type: 'scenario',
          title: '✈️ Araştırma Yapmadan Gelen Aday',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'What do you know about our company\'s recent achievements?',
              translation: 'Şirketimizin son başarıları hakkında ne biliyorsunuz?'
            },
            {
              speaker: 'Aday (Hazırlıksız)',
              text: 'Um... I know you\'re a big airline and you fly to many places. I\'ve heard you\'re good.',
              translation: 'Şey... Büyük bir havayolu olduğunuzu ve birçok yere uçtuğunuzu biliyorum. İyi olduğunuzu duydum.'
            },
            {
              speaker: 'Mülakatçı (düşüncesi)',
              text: '(This candidate didn\'t even bother to Google us. Red flag.)',
              translation: '(Bu aday bizi Google\'lamaya bile zahmet etmemiş. Kırmızı bayrak.)'
            }
          ]
        },
        {
          type: 'scenario',
          title: '✈️ İyi Araştırma Yapan Aday',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'What do you know about our company\'s recent achievements?',
              translation: 'Şirketimizin son başarıları hakkında ne biliyorsunuz?'
            },
            {
              speaker: 'Aday (Hazırlıklı)',
              text: 'I was excited to read that you won the Skytrax Best Business Class award again this year. I also noticed you\'ve launched several new routes to Southeast Asia, and your sustainability report mentioned ambitious carbon reduction targets by 2030.',
              translation: 'Bu yıl tekrar Skytrax En İyi Business Class ödülünü kazandığınızı okumaktan heyecan duydum. Ayrıca Güneydoğu Asya\'ya birçok yeni rota başlattığınızı fark ettim ve sürdürülebilirlik raporunuz 2030\'a kadar iddialı karbon azaltma hedeflerinden bahsediyordu.'
            },
            {
              speaker: 'Mülakatçı (düşüncesi)',
              text: '(This candidate did their homework. They\'re serious about joining us.)',
              translation: '(Bu aday ödevini yapmış. Bize katılma konusunda ciddiler.)'
            }
          ]
        },
        {
          type: 'tip',
          content: '💡 **Pro İpucu:** Araştırmanızı mülakata doğal şekilde serpiştirin:\n\n"I was reading that..." \n"I noticed on your website..."\n"I saw a recent interview with your CEO where..."\n\nBu, gerçekten ilgilendiğinizi gösterir.'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Mülakat öncesi araştırmada EN ÖNEMLİ kaynak:',
          options: [
            'Sadece şirket web sitesi',
            'Web sitesi + son haberler + çalışan yorumları kombinasyonu',
            'Arkadaşlardan duyumlar',
            'Sadece maaş bilgileri'
          ],
          correctIndex: 1,
          explanation: 'Çok kaynaklı araştırma tam resmi verir: resmi bilgi + güncel gelişmeler + içeriden görüş.'
        }
      ]
    }
  },

  'C1INT-U2-EXAM': {
    id: 'C1INT-U2-EXAM',
    title: 'Unit 2 Exam: Airline-Specific Questions',
    type: 'exam',
    content: {
      timeLimit: 25,
      passingScore: 80,
      questions: [
        {
          type: 'multipleChoice',
          question: 'What is Turkish Airlines\' most important differentiator?',
          options: [
            'Cheapest tickets',
            'Airline flying to the most countries + Turkish hospitality',
            'Biggest aircraft',
            'Oldest airline'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'In an Emirates interview, how should you answer "Are you willing to relocate?"',
          options: [
            '"I need to think about it"',
            '"Let me ask my family"',
            '"Absolutely yes, I am excited to live in Dubai"',
            '"It depends on the salary"'
          ],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'What is emphasized in British Airways culture?',
          options: [
            'Glamour and luxury',
            'Quiet professionalism and composure',
            'Entertainment and parties',
            'Aggressive sales'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'What is the most effective answer to "What sets you apart?"',
          options: [
            'I am very hardworking',
            'A specific story + how you will contribute to aviation',
            'My physical features',
            'My diplomas'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'What should you research before an interview?',
          options: [
            'Only salary',
            'Only location',
            'Hub cities, fleet, recent news, awards, and values',
            'Only uniform'
          ],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'How should you answer "Why do you want to work for our airline specifically?"',
          options: [
            'I applied to many airlines and you responded first',
            'Your values align with mine, and I admire your service excellence',
            'I need a job',
            'My friend works there'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'What does Qatar Airways emphasize in their service?',
          options: [
            'Budget travel',
            'Five-star hospitality and luxury',
            'Speed over service',
            'Self-service'
          ],
          correctIndex: 1
        }
      ]
    }
  }
};

export default C1INT_UNIT_2;
